module.exports = __webpack_public_path__ + "static/media/image-1200.5d727df6.jpg";